import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import PasswordResetMailAddressForm from "@/components/Form/PasswordResetMailAddressForm.js";
import { useAccountSendPasswordResetTokenMutation } from "@/hooks";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import PasswordResetComplete from "@/components/PasswordResetComplete.js";
import PasswordRemindMetaTags from "@/components/MetaTags/PasswordRemindMetaTags";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PasswordRemind() {
  var router = useRouter();

  var _useState = useState(false),
      complete = _useState[0],
      setComplete = _useState[1];

  var _useState2 = useState(""),
      mailAddress = _useState2[0],
      setMailAddress = _useState2[1];

  var _useAccountSendPasswo = useAccountSendPasswordResetTokenMutation({
    onCompleted: function onCompleted(_ref) {
      var sendPasswordResetToken = _ref.sendPasswordResetToken;

      if (sendPasswordResetToken !== null && sendPasswordResetToken !== void 0 && sendPasswordResetToken.result) {
        setComplete(true);
        window.scrollTo(0, 0);
      }
    }
  }),
      _useAccountSendPasswo2 = _slicedToArray(_useAccountSendPasswo, 1),
      accountSendPasswordResetTokenMutation = _useAccountSendPasswo2[0];

  var handleBack = useCallback(function () {
    router.back();
  }, []);
  var handleSubmit = useCallback(function (data) {
    setMailAddress(data.mailAddress);
    accountSendPasswordResetTokenMutation({
      variables: {
        mailAddress: data.mailAddress
      }
    });
  }, []);
  var handleClick = useCallback(function () {
    router.push(routes.login);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PasswordRemindMetaTags, {
      type: complete ? "complete" : null
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.inner,
        children: [/*#__PURE__*/_jsx("h2", {
          className: "".concat(processStyles.heading, " ").concat(processStyles.withoutSteps),
          children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F\u65B9"
        }), /*#__PURE__*/_jsxs("div", {
          children: [complete == false && /*#__PURE__*/_jsx(PasswordResetMailAddressForm, {
            handleBack: handleBack,
            onSubmit: handleSubmit
          }), complete == true && /*#__PURE__*/_jsx(PasswordResetComplete, {
            handleClick: handleClick,
            mailAddress: mailAddress
          })]
        })]
      })
    })]
  });
}
PasswordRemind.layout = "NoHeaderLayout";